// <editor-fold desc="Action Types">
export enum ActionTypes {
    /**
     * Request
     */
    AddDeepzoomRequest = '[REQUEST | CONTROL | DEEPZOOM] Add Deepzoom Request',
    AddDeepzoomSuccess = '[REQUEST | CONTROL | DEEPZOOM] Add Deepzoom Success',
    CreateSlideFromMediaRequest = '[REQUEST | CONTROL | DEEPZOOM] Create Slide From Media Request',
    CreateSlideFromMediaSuccess = '[REQUEST | CONTROL | DEEPZOOM] Create Slide From Media Success',
  }
    
  // </editor-fold>
  
  // <editor-fold desc="Request">
  
  export class AddDeepzoomRequest {
    public static readonly type = ActionTypes.AddDeepzoomRequest;

    constructor(public key: string) {
        
    }
  }

  export class AddDeepzoomSuccess {
    public static readonly type = ActionTypes.AddDeepzoomSuccess;

    constructor(public mediaId: string) {

    }
  }
  
  export class CreateSlideFromMediaRequest {
    public static readonly type = ActionTypes.CreateSlideFromMediaRequest;

    constructor(public title: string, public mediaIds: string[]) {
    }
  }

  export class CreateSlideFromMediaSuccess {
    public static readonly type = ActionTypes.CreateSlideFromMediaSuccess;

    constructor(public slideId: string) {
    }
  }
  
  // </editor-fold>
  